import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Card,
  CardContent,
  CardHeader,
  Typography,
  Collapse,
  Divider,
  IconButton,
  CardActions,
  Button,
  Grid,
  Box,
} from "@mui/material";
import { CopyAll, ExpandLess, ExpandMore } from "@mui/icons-material";
import { Client, useRemoveClientMutation } from "../../apis/clients";

interface Props {
  client: Client;
  index: number;
}

const ClientCard = ({ client, index }: Props) => {
  const [removeClient] = useRemoveClientMutation();
  const [show, setShow] = useState(index === 0);
  const handleClick = () => setShow((prev) => !prev);
  const handleRemove = () => removeClient(client.id);
  const handleCopy = async () => {
    await window.navigator.clipboard.writeText(client.key);
  };
  const navigate = useNavigate();
  const handleEdit = () => {
    navigate("/clients/edit", { state: client });
  };

  return (
    <Card>
      <CardHeader
        title={client.name}
        action={
          <IconButton onClick={handleClick}>
            {show ? <ExpandLess fontSize="large" /> : <ExpandMore fontSize="large" />}
          </IconButton>
        }
      />
      <Collapse in={show}>
        <CardContent sx={{ pt: 0 }}>
          <Grid container spacing={3}>
            <Grid item md={6}>
              <Typography variant="subtitle1" gutterBottom>
                URL
              </Typography>
              <Typography variant="body2">{client.url}</Typography>
            </Grid>
            <Grid item md={6}>
              <Typography variant="subtitle1" gutterBottom>
                Description
              </Typography>
              <Typography variant="body2">{client.description}</Typography>
            </Grid>
            <Grid item md={6}>
              <Box display="flex" alignItems="center">
                <Typography variant="subtitle1" gutterBottom mr={1}>
                  API Key
                </Typography>
                <IconButton color="primary" size="small" onClick={handleCopy}>
                  <CopyAll />
                </IconButton>
              </Box>
              <Typography variant="body2">{client.key}</Typography>
            </Grid>
            <Grid item md={6}>
              <Typography variant="subtitle1" gutterBottom>
                Create Date
              </Typography>
              <Typography variant="body2">{new Date(client.createAt).toLocaleString()}</Typography>
            </Grid>
          </Grid>
        </CardContent>
        <Divider />
        <CardActions sx={{ justifyContent: "end" }}>
          <Button variant="contained" color="error" onClick={handleRemove}>
            Delete
          </Button>
          <Button variant="contained" onClick={handleEdit} color="secondary">
            Edit
          </Button>
        </CardActions>
      </Collapse>
    </Card>
  );
};

export default ClientCard;
